import get from "lodash/get";

import { MULTI_PARTNER_PERSONA, UPLOADED } from "../../constants";
import { ensureBearerToken } from "../../utils/genericUtils";
import { checkLoginStatus, getAgentId as getAgentUserId } from "./loginSelector";

export const getAgentName = state => state.appConfig.login.userName;

export const getAppConfig = state => state.appConfig || {};

export const getAppConfigLoading = state => getAppConfig(state).loading;

export const getUploadDocuments = state => state.uploadDocuments || {};

export const getDatalist = state => getAppConfig(state).datalist || {};

export const getSignatoryModel = state => getAppConfig(state).signatoryModel || {};

export const getOrganizationInfoModel = state => getAppConfig(state)?.organizationInfoModel || {};

export const getReCaptchaSiteKey = state => getAppConfig(state).reCaptchaSiteKey;

export const getIsRecaptchaEnable = state =>
  process.env.REACT_APP_RECAPTCHA_ENABLE?.toLowerCase() === "y" ||
  getAppConfig(state).recaptchaEnable;

export const getFreeFieldsInfo = state => getProspect(state).freeFieldsInfo || {};

export const getServicePricingGuideUrl = state => getAppConfig(state).servicePricingGuideUrl;

export const getAuthToken = state => getAppConfig(state).authorizationToken;

export const getAuthRefreshToken = state => getAppConfig(state).refreshToken || null;

export const getProspect = state => getAppConfig(state).prospect || {};

export const getInitialProspectTableCheck = state => getAppConfig(state).initialProspectTableCheck;

export const getSignatories = state => getProspect(state).signatoryInfo || [];

export const getInitialKycEditCheck = state => getAppConfig(state).iskycInitialEdit;

export const getSignatoriesCount = state => getSignatories(state).length;

export const getAccountInfo = state => getProspect(state).accountInfo || [];

export const getAccountCurrencies = state => get(getAccountInfo(state)[0], "accountCurrencies", "");

export const getExpressTandC = state => get(getAccountInfo(state)[0], "expressTandC", false);

export const getOrganizationInfo = state => getProspect(state).organizationInfo || {};

export const getKycAnnexureDetails = state => getProspect(state).kycAnnexure || {};

export const getPrimaryMobCountryCode = state =>
  get(getOrganizationInfo(state), "contactDetails.primaryMobCountryCode", "");

export const getCompanyName = state => getOrganizationInfo(state).companyName;

export const getCompanyTradeLicenseNumber = state => getOrganizationInfo(state).licenseOrCOINumber;

export const getOrgKYCDetails = state => getProspect(state).orgKYCDetails || {};

export const getGeneralInfo = state => getProspect(state).generalInfo || {};

export const getProspectId = state => getGeneralInfo(state).prospectId || "";

export const getApplicantInfo = state => getProspect(state).applicantInfo || {};

export const getPersona = state => getApplicantInfo(state).persona || "";

export const getApplicantFullName = state => getApplicantInfo(state).fullName;

export const getApplicantEditedFullName = state => getSignatories(state)[0]?.editedFullName;

export const getApplicantEmail = state => getApplicantInfo(state).email;

export const getApplicantMobileNo = state => getApplicantInfo(state).mobileNo;

export const getRoEmail = state => getAppConfig(state).roEmail;

// ro-assist-brd3-3
export const getValidRoCode = state => {
  const validRoCode = getApplicantInfo(state).validRoCode || "N";
  return validRoCode === "Y" ? true : false;
};

export const getApplicationInfo = state => getProspect(state).applicationInfo || {};

export const getIsIslamicBanking = state => getApplicationInfo(state).islamicBanking;

export const getIsIslamicBankingFromApplicantInfo = state => getApplicantInfo(state).isIslamic;

export const getAccountType = state =>
  getApplicationInfo(state).accountType || getApplicantInfo(state).productType;

export const getAccountTypeFromApplicationInfo = state => getApplicationInfo(state).accountType;

export const getRakValuePackage = state => getApplicationInfo(state).rakValuePackage || "";

export const getDocuments = state => getProspect(state).documents || {};

export const getCompanyDocuments = state => getDocuments(state).companyDocuments || [];

export const getCompanyBankStatements = state => getDocuments(state).companyBankStatements || [];

export const getCompanyAddressProof = state => getDocuments(state).companyAddressProof || [];

export const getCompanyInvoices = state => getDocuments(state).companyInvoices || [];

export const getDocumentUplaoderAuthToken = state =>
  getUploadDocuments(state).authToken?.token || null;

export const getDocumentsList = state => getUploadDocuments(state).documentList || null;

export const getDocumentUploadCnt = state => {
  const companyDocuments = getCompanyDocuments(state);
  let DocumentUploadCnt = 0;
  if (companyDocuments[0]) {
    DocumentUploadCnt = companyDocuments[0].DocumentUploadCnt;
  }
  return DocumentUploadCnt;
};

export const getStakeholdersDocuments = state => getDocuments(state).stakeholdersDocuments || [];

export const getOtherDocuments = state => getDocuments(state).otherDocuments || [];

export const checkIfRequiredDocsUploaded = docs =>
  docs.length && docs.filter(doc => doc.required).every(doc => doc.uploadStatus === UPLOADED);

export const getIsRequiredDocsUploaded = state => {
  // ro-assist-brd3-3 starts
  if (getValidRoCode(state)) {
    return true;
  }
  // // ro-assist-brd3-3 end
  const { companyDocuments, stakeholdersDocuments } = getDocuments(state);
  // ro-assist-brd2-1
  const companyBankStatements = getCompanyBankStatements(state).documents || [];
  const companyAddressProof = getCompanyAddressProof(state).documents || [];
  const companyInvoices = getCompanyInvoices(state).documents || [];
  const stakeholdersDocsFlattened = Object.values(stakeholdersDocuments || {}).reduce(
    (acc, { documents, personalBankStatements, personalBackground }) => [
      ...acc,
      ...documents,
      ...(personalBankStatements ? personalBankStatements.documents : []),
      ...(personalBackground ? personalBackground.documents : [])
    ],
    []
  );

  return checkIfRequiredDocsUploaded([
    ...(companyDocuments || []),
    ...companyBankStatements,
    ...companyAddressProof,
    ...companyInvoices,
    ...stakeholdersDocsFlattened
  ]);
};

export const getUrlsReadMore = state => ({
  rakValuePlusReadMoreUrl: getAppConfig(state).rakValuePlusReadMoreUrl,
  rakValueMaxReadMoreUrl: getAppConfig(state).rakValueMaxReadMoreUrl,
  rakValuePlusIslamicReadMoreUrl: getAppConfig(state).rakValuePlusIslamicReadMoreUrl,
  rakValueMaxIslamicReadMoreUrl: getAppConfig(state).rakValueMaxIslamicReadMoreUrl
});

export const getAuthorizationHeader = state => {
  const authToken = getAuthToken(state);
  const refreshToken = getAuthRefreshToken(state);
  const isAgentLoggedIn = checkLoginStatus(state);
  const mobileNo = getApplicantMobileNo(state);
  const prospectId = getProspectId(state);
  const viewId = getApplicationInfo(state).viewId;

  const headers = authToken ? { Authorization: ensureBearerToken(authToken) } : {};

  if (refreshToken) {
    headers["refresh-token"] = refreshToken;
  }

  if (mobileNo) {
    headers["mobile-no"] = mobileNo;
  }

  if (prospectId) {
    headers["prospect-id"] = prospectId;
  }

  if (viewId) {
    headers["stage-id"] = viewId;
  }

  if (isAgentLoggedIn) {
    const agentName = getAgentUserId(state);
    if (agentName) {
      headers["user-id"] = agentName;
    }
  }
  return {
    headers: Object.keys(headers).length > 0 ? headers : {}
  };
};

export const getDocuploaderHeader = state => {
  const authToken = getDocumentUplaoderAuthToken(state);

  return {
    headers: authToken
      ? { Authorization: `${authToken}`, Accept: "application/json" }
      : { Accept: "application/json" }
  };
};

export const createGetAuthorityTypeDisplayText = authorityType => state => {
  const authorityTypeFromDatalist =
    getDatalist(state).authorityType.find(item => item.value === authorityType) || {};

  return authorityTypeFromDatalist.displayText || "";
};

export const getLeadSource = state => {
  return typeof state.appConfig.leadSource !== "undefined" ? state.appConfig.leadSource : "";
};

export const getRoCode = state => {
  return typeof state.appConfig.roCode !== "undefined" ? state.appConfig.roCode : "";
};

export const getExpired = state => getAppConfig(state).expired;

export const getIsLemniskEnable = state => {
  return typeof state.appConfig.lemniskEnable !== "undefined"
    ? state.appConfig.lemniskEnable
    : false;
};

export const getCompanyAdditionalInfo = state => getProspect(state).companyAdditionalInfo || {};

export const isFieldTouched = id => state => getProspect(state).fields?.[id]?.touched;

export const getAdditionalInfoDetailsFromBPM = state =>
  getProspect(state).notifyApplicationRequest?.additionalInfoDetailsFromBPM;

export const getAdditionalDocumentDetailsFromBPM = state =>
  getProspect(state).notifyApplicationRequest?.additionalDocumentDetailsFromBPM;

export const getAdditionalInfoDetailsForBPM = state =>
  getProspect(state).additionalDataForBPM?.additionalInfoBPM || [];

export const getAdditionalDocumentDetailsForBPM = state =>
  getProspect(state).additionalDataForBPM?.additionalDocumentsBPM || [];

export const getSearchInputDetails = state => getAppConfig(state).searchInfo;

export const getAccordionStatuses = state => getProspect(state).accordionsStatus || "{}";

export const getTat = state => {
  return typeof state.appConfig.tat !== "undefined" ? state.appConfig.tat : "";
};

export const getIsAutoSaveEnabled = state => getDatalist(state)?.AutoSave;

export const getIsChequeBookNameFieldEnabled = state =>
  getDatalist(state)?.isChqbookNameEditable?.[0]?.displayText === "true";

export const getUserJourneyType = state => getProspect(state).userJourneyType || "";

export const getIsMobileChanged = state => getAppConfig(state)?.isMobileNumberChanged;

export const getIsEmailChanged = state => getAppConfig(state)?.isEmailIdChanged;

export const getIsSignatoryPrimaryEmailChanged = state =>
  getAppConfig(state)?.isSignatoryPrimaryEmailChanged;

export const getIsSignatoryPrimaryMobileNoChanged = state =>
  getAppConfig(state)?.isSignatoryPrimaryMobileNoChanged;

export const getPartnersDetailInfo = state => getProspect(state).partnersDetailInfo;

export const getCustomerSatisfaction = state => {
  const customerSatisfactionArray = getDatalist(state).customerSatisfaction;

  const customerSatisfactionObject = customerSatisfactionArray.reduce((acc, item) => {
    acc[item.code] = item.displayText;
    return acc;
  }, {});

  return customerSatisfactionObject;
};
export const getIsMultiPartnerJourney = state => {
  return MULTI_PARTNER_PERSONA.includes(getPersona(state)) ? true : false;
};
